import { DIRECT_ONLY_IS_ACTIVE_DEFAULT } from '../constants';
import * as types from '../types';

function setDirectOnlyActive(state, action) {
    const {
        meta: filterId,
        payload: isActive,
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            directOnly: isActive,
        },
    };
}

function resetDirectOnly(state, action) {
    const { meta: filterId } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            directOnly: DIRECT_ONLY_IS_ACTIVE_DEFAULT,
        },
    };
}

export default {
    [types.SET_DIRECT_ONLY_ACTIVE]: setDirectOnlyActive,
    [types.RESET_DIRECT_ONLY]: resetDirectOnly,
};
